<template>
    <div class="col-lg-6">
        <!-- Target group(s) -->
        <h4 class="card-title">{{ $t('monitoring.field_title__target_groups') }}</h4>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_local_communities"
                >
                {{ $t('monitoring.field_target_groups_keyword_local_communities') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_youth"
                >
                {{ $t('monitoring.field_target_groups_keyword_youth') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_women"
                >
                {{ $t('monitoring.field_target_groups_keyword_women') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_private_sector"
                >
                {{ $t('monitoring.field_target_groups_keyword_private_sector') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_farmers_fishermen"
                >
                {{ $t('monitoring.field_target_groups_keyword_farmers_fishermen') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_subnational_governments"
                >
                {{ $t('monitoring.field_target_groups_keyword_subnational_governments') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_national_government"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_government') }}
            </base-checkbox>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        loggedUser: Object,
        UserRoles: Object,
        MonitoringForm: Object
    }

}

</script>
<style lang="scss" scoped>
.grant-agreement
{
    counter-reset: title_counter;
    // counter-reset: subtitle_counter;

    .card-title
    {
        counter-increment: title_counter;
        counter-reset: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '. '
        }
    }

    .card-subtitle
    {
        margin: 10px 0;
        counter-increment: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '.' counter(subtitle_counter) '. '
        }
    }
}
</style>
